import { AuthInitializer } from '@qse/auth-ui'
import { UrlNormalizer } from '@qse/utils'

import AppRoutes from './router'

function App() {
  return (
    <AuthInitializer>
      <UrlNormalizer />
      <AppRoutes />
    </AuthInitializer>
  )
}

export default App
